/**
 * @module web/store
 * @private
 */

let playbackToken = null;

/**
 * Update the session user playpack token with the given newToken. This token will be saved in memory.
 * @param {String} newToken - Playback token obtained from a playback token retrieval request through a backend call.
 * @public
 */
const update = function(newToken) {
  playbackToken = newToken;
};

/**
 * Returns the current stored playback token, if any, which will be searched in memory.
 * @returns {string} - A found stored playback token or null if memory does not have a valid one.
 * @public
 */
const get = function() {
  return playbackToken;
};

export default { update, get };
